"use strict";
exports.__esModule = true;
var React = require("react");
var operation_1 = require("../common/operation");
var useGoogleApi_1 = require("../hooks/useGoogleApi");
var MapView = function (props) {
    var previousOptsRef = React.useRef();
    var previousObjectsRef = React.useRef();
    var isSdkLoaded = useGoogleApi_1.useGoogleAPI();
    var _a = React.useState(), opts = _a[0], setOpts = _a[1];
    var _b = React.useState(), map = _b[0], setMap = _b[1];
    var _c = React.useState(), objects = _c[0], setObjects = _c[1];
    var _d = React.useState(), id = _d[0], setId = _d[1];
    React.useEffect(function () {
        if (!isSdkLoaded)
            return;
        setId(props.id);
        setMap(props.map);
        setOpts(props.opts);
        setObjects(props.objects);
        props.isReady ? props.isReady() : '';
    }, [isSdkLoaded]);
    React.useEffect(function () {
        if (!isSdkLoaded)
            return;
        setOpts(props.opts);
    }, [props.opts]);
    React.useEffect(function () {
        if (opts) {
            if (previousOptsRef.current && map) {
                operation_1.mapMove(map, opts);
            }
            else {
                var map2 = operation_1.mapCreate(id, opts);
                setMap(map2);
            }
            previousOptsRef.current = opts;
            return;
        }
        if (map && !opts && objects && objects.length > 0) {
            operation_1.mapFitBound(map, objects);
        }
    }, [opts]);
    React.useEffect(function () {
        if (!isSdkLoaded)
            return;
        setObjects(props.objects);
    }, [props.objects]);
    React.useEffect(function () {
        if (!map)
            return;
        if (previousObjectsRef.current === objects)
            return;
        if (previousObjectsRef.current) {
            operation_1.mapSetObjects(map);
        }
        operation_1.mapSetObjects(map, objects, props.onMouseevent);
        if (!opts) {
            operation_1.mapFitBound(map, objects);
        }
        setObjects(objects);
        previousObjectsRef.current = objects;
    }, [objects, map]);
    return id ? (React.createElement("div", { id: id, style: { width: '100%', height: '100%' } })) : null;
};
exports.MapView = MapView;
